import { useTranslation as e } from "../../i18n.mjs";
import { isImageSelected as t } from "../image-extension/utils/is-image-selected.mjs";
import { toolbarActionItem as n } from "../../components/content-controls/toolbar-action-item.mjs";
import { IndentProps as r } from "./indent.mjs";
import { useEditorState as i } from "@tiptap/react";
import { useMemo as a } from "react";
import { jsx as o } from "react/jsx-runtime";
import { LeftIndent01Icon as s, RightIndent01Icon as c } from "@systemeio/icons";
//#region src/extensions/indent-extension/use-indent-extension-toolbar.tsx
var l = (e) => {
	if (!e) return 0;
	for (let t of [
		"paragraph",
		"heading",
		"bulletList",
		"orderedList"
	]) {
		let n = e.getAttributes(t);
		if (n && typeof n.indent == "number") return n.indent;
	}
	return 0;
}, u = (u) => {
	let { t: d } = e(), f = i({
		editor: u,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			currentIndent: l(e),
			isImageSelected: t(e)
		})
	}), p = f?.currentIndent ?? 0, m = !f?.isEditable || !!f?.isImageSelected || p <= r.min, h = !f?.isEditable || !!f?.isImageSelected || p >= r.max;
	return a(() => {
		let e = {
			Icon: s,
			disabled: m,
			label: d("decrease_intent"),
			onClick: () => u?.chain().focus().outdent().run()
		}, t = {
			Icon: c,
			disabled: h,
			label: d("increase_intent"),
			onClick: () => u?.chain().focus().indent().run()
		}, r = ({ Icon: e, disabled: t, label: r, onClick: i }) => n({
			disabled: t,
			icon: /* @__PURE__ */ o(e, {}),
			label: r,
			onClick: i
		});
		return [r(e), r(t)];
	}, [
		u,
		h,
		m,
		d
	]);
};
//#endregion
export { u as useIndentExtensionToolbar };
